import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useHistory, Link } from 'react-router-dom';
import Menu from '../../molecules/Header';
import CategoryCard from '../../atoms/CategoryCard';
import CardCategoryAll from '../../atoms/CategoryCardAll';
import Btn from '../../atoms/Btn';
import Txt from '../../atoms/Txt';
import MainContent from '../../molecules/MainContent';

import {
  Caixa,
  Card,
  Categorio,
  ColunCategorio,
  Container,
  Numero1,
  Numero2,
  Products,
  SearchBarra,
  MoreAnunc,
  AllProducts
} from './styles';
import Footer from '../../molecules/Footer';
import ProductCard from '../../molecules/ProductCard';
import categories from '../../../constants/ProductCategories';

import { listProducts } from '../../../database/repositories/ProductRepository';
import { getSearchPath, useSearchPath } from '../../../hooks/useSeachPath';

function Search() {
  const history = useHistory();
  const { search } = useLocation();
  const query = useMemo(() => new URLSearchParams(search), [search]);
  const queryCategory = useMemo(() => query.get('category'), [query]);
  const queryQ = useMemo(() => query.get('q'), [query]);
  const sortBy = useMemo(() => query.get('sortBy'), [query]);
  const sortOrder = useMemo(() => query.get('sortOrder'), [query]);

  const [prodList, setProdList] = useState([]);
  const [searchString, setSearchString] = useState(queryQ);

  const searchPath = useSearchPath(searchString, queryCategory, sortBy, sortOrder);

  const fetchProducts = useCallback(() => {
    listProducts({ category: queryCategory, query: queryQ, sortBy, sortOrder }).then(setProdList);
  }, [queryCategory, queryQ, sortBy, sortOrder]);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  const changeCurrentUri = (category) => {
    const path = getSearchPath(searchString, category, sortBy, sortOrder);
    history.replace(path);
  };

  return (
    <Container>
      <Menu />
      <div style={{ backgroundColor: '#002666', padding: '2% 0' }}>
        <MainContent>
          <Card>
            <div style={{ flex: '1', display: 'flex' }}>
              <Txt color="#fff" size="15pt">
                Voltar para
              </Txt>
              <Txt
                color="#ffb615"
                href="/"
                size="15pt"
                style={{ textDecoration: 'underline', marginLeft: '5px' }}>
                Home
              </Txt>
            </div>
            <div style={{ display: 'flex' }}>
              <Txt color="#ffb615" size="15pt" bold>
                Seu primeiro anúncio por apenas R$ 10
              </Txt>
              <Txt color="#fff" size="15pt" bold style={{ marginLeft: '5px' }}>
                e com lugar garantido nos destaques pra vender seu Kacareco ainda mais rápido
              </Txt>
            </div>
          </Card>
          <SearchBarra>
            <form>
              <input
                type="text"
                value={searchString}
                placeholder="Estou procurando por..."
                onChange={(e) => {
                  const { value } = e.target;
                  setSearchString(value);
                }}
              />

              <button
                type="submit"
                href={searchPath}
                onClick={(event) => {
                  event.preventDefault();
                  changeCurrentUri(queryCategory);
                }}>
                Encontrar
              </button>
            </form>
          </SearchBarra>

          <Caixa>
            <div
              style={{
                width: '12%'
              }}>
              <Txt color="#ffb615" bold size="20px">
                Categorias
              </Txt>

              <Categorio>
                <ColunCategorio>
                  {categories.slice(0, 5).map(({ title, icon, params }) => (
                    <CategoryCard
                      href={params}
                      title={title}
                      icon={icon}
                      selected={queryCategory === params.state.searchedCategory}
                      style={{ marginBottom: 18 }}
                      onClick={() =>
                        changeCurrentUri(
                          queryCategory === params.state.searchedCategory
                            ? null
                            : params.state.searchedCategory
                        )
                      }
                    />
                  ))}
                </ColunCategorio>
                <ColunCategorio>
                  {categories.slice(5, 10).map(({ title, icon, params }) => (
                    <CategoryCard
                      href={params}
                      title={title}
                      icon={icon}
                      selected={queryCategory === params.state.searchedCategory}
                      style={{ marginBottom: 18 }}
                      onClick={() =>
                        changeCurrentUri(
                          queryCategory === params.state.searchedCategory
                            ? null
                            : params.state.searchedCategory
                        )
                      }
                    />
                  ))}
                </ColunCategorio>
              </Categorio>
              <CardCategoryAll
                title="Ver todas"
                active="2"
                icon=" fas fa-th-large"
                onClick={() => changeCurrentUri('todas')}
              />
            </div>
            <AllProducts>
              <Card style={{}}>
                <Txt bold color="#ffff" size="26px">
                  Destaques
                </Txt>

                <MoreAnunc>
                  <Txt bold color="#fff" size="20px">
                    Quer vender mais rapido?
                  </Txt>
                  <Txt
                    size="20px"
                    style={{ textDecoration: 'underline', marginLeft: '10px' }}
                    bold
                    color="#ffb615"
                    href="/produto/cadastro">
                    Coloque seu anúncio aqui
                  </Txt>
                </MoreAnunc>
              </Card>

              <Products>
                {prodList.length > 0
                  ? prodList.map((item) => <ProductCard productData={item} color="white" />)
                  : <span>Nenhum produto encontrado</span>}
              </Products>
            </AllProducts>
          </Caixa>
          <Card>
            <Numero1>
              <Txt size="20" bold>
                Visite nossa sessão de ferramentas e encontre o que você precisa!
              </Txt>
            </Numero1>
            <Numero2>
              <Link to="busca?category=ferramentas">
                <Btn title="Ver mais" />
              </Link>
            </Numero2>
          </Card>
        </MainContent>
      </div>
      <Footer />
    </Container>
  );
}

export default Search;
